import Api from '@/services/Api'

const URL = 'cat/producto-tienda/';

export default {
    
    fetch(params) {
        return Api().get(URL,{
            params: params
        })
    },
    getById(sku) {
        return Api().get(URL + sku)
    },
    save(params) {
        let url = URL;
        if ('id' in params) {
            return Api().put(url + params.id + '/', params)
        }
        return Api().post(url, params)
    },
    
}